import { Loader } from '@/components/loader';

import { ErrorCard } from '../../components/gradient-layout/cards';

import commonStyles from '../public.module.scss';

export const OAuthLoading = ({ title = 'Connecting…' }: { title?: string }) => (
  <div className={commonStyles.layout}>
    <h1>{title}</h1>
    <Loader type="spinner" size="large" />
  </div>
);

export const OAuthError = ({ children }: { children: React.ReactNode }) => (
  <div className={commonStyles.layout}>
    <ErrorCard>{children}</ErrorCard>
  </div>
);
